// ── Icons ───────────────────────────────────────────────────────────────────
function DashboardIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  )
}
function MatchIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </svg>
  )
}
function WidgetIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2"/>
      <path d="M8 21h8"/><path d="M12 17v4"/>
    </svg>
  )
}
function SettingsIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  )
}
function WizardIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/>
      <path d="M9 18h6"/><path d="M10 22h4"/>
    </svg>
  )
}

// ── Nav item ────────────────────────────────────────────────────────────────
function NavItem({ id, label, description, icon, badge, isActive, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left transition-colors group ${
        isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
      }`}
    >
      <div className={`flex-shrink-0 transition-colors ${isActive ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'}`}>
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <div className={`text-sm font-medium truncate ${isActive ? 'text-blue-700' : ''}`}>{label}</div>
        {description && <div className="text-xs text-gray-400 truncate">{description}</div>}
      </div>
      {badge != null && badge > 0 && (
        <span className="badge bg-amber-100 text-amber-700 text-xs flex-shrink-0">{badge}</span>
      )}
    </button>
  )
}

// ── Sidebar ─────────────────────────────────────────────────────────────────
export default function Sidebar({ currentPage, onNavigate, trialDaysLeft, onSetTrialDays, billingState, onSetBillingState }) {
  return (
    <aside className="w-60 bg-white border-r border-gray-200 flex flex-col flex-shrink-0">

      {/* Brand */}
      <div className="px-5 py-5 border-b border-gray-100">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
            <span className="text-white text-xs font-bold tracking-tight">BJ</span>
          </div>
          <div className="min-w-0">
            <div className="text-sm font-semibold text-gray-900 leading-tight">BillJean</div>
            <div className="text-xs text-gray-400 leading-tight">Stripe for Salesforce</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-3 space-y-4 overflow-y-auto">

        {/* Main */}
        <div className="space-y-0.5">
          <NavItem id="dashboard" label="Dashboard"        description="Overview & activity"    icon={<DashboardIcon />} isActive={currentPage === 'dashboard'} onClick={() => onNavigate('dashboard')} />
          <NavItem id="matching"  label="Account Matching" description="Review & manage"        icon={<MatchIcon />}     isActive={currentPage === 'matching'}  onClick={() => onNavigate('matching')}  badge={4} />
          <NavItem id="widget"    label="Widget Preview"   description="Sales rep view"         icon={<WidgetIcon />}    isActive={currentPage === 'widget'}    onClick={() => onNavigate('widget')} />
          <NavItem id="settings"  label="Settings"         description="Connections & agents"   icon={<SettingsIcon />}  isActive={currentPage === 'settings'}  onClick={() => onNavigate('settings')} />
        </div>

        {/* Demo section */}
        <div className="space-y-0.5">
          <p className="section-label px-3 pt-1 pb-1">Demo</p>
          <NavItem id="wizard" label="Setup Wizard" description="Onboarding flow" icon={<WizardIcon />} isActive={currentPage === 'wizard'} onClick={() => onNavigate('wizard')} />
        </div>


      </nav>

      {/* Trial state switcher */}
      <div className="px-4 py-3 border-t border-gray-100 space-y-2">
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Trial state</p>
        <div className="grid grid-cols-4 gap-1">
          {[
            { days: 10, label: '10d' },
            { days: 3,  label: '3d'  },
            { days: 1,  label: '1d'  },
            { days: 0,  label: 'Exp' },
          ].map(({ days, label }) => {
            const isActive = billingState === 'ok' && trialDaysLeft === days
            return (
              <button
                key={days}
                onClick={() => onSetTrialDays(days)}
                className={`py-1 text-xs rounded-md font-medium transition-colors ${
                  isActive
                    ? days === 0 ? 'bg-red-500 text-white'
                      : days <= 3 ? 'bg-orange-500 text-white'
                      : 'bg-amber-400 text-white'
                    : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                }`}
              >
                {label}
              </button>
            )
          })}
        </div>
      </div>

      {/* Billing state switcher */}
      <div className="px-4 py-3 border-t border-gray-100 space-y-2">
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Billing state</p>
        <div className="grid grid-cols-4 gap-1">
          {[
            { state: 'ok',        label: 'OK'   },
            { state: 'grace-5',   label: '5d'   },
            { state: 'grace-1',   label: '1d'   },
            { state: 'suspended', label: 'Susp' },
          ].map(({ state, label }) => {
            const isActive = billingState === state
            return (
              <button
                key={state}
                onClick={() => onSetBillingState(state)}
                className={`py-1 text-xs rounded-md font-medium transition-colors ${
                  isActive
                    ? state === 'suspended' ? 'bg-red-500 text-white'
                      : state === 'grace-1' ? 'bg-orange-500 text-white'
                      : state === 'grace-5' ? 'bg-amber-400 text-white'
                      : 'bg-green-500 text-white'
                    : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                }`}
              >
                {label}
              </button>
            )
          })}
        </div>
      </div>

      {/* Footer */}
      <div className="px-4 py-3 border-t border-gray-100">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-green-400 flex-shrink-0" />
          <span className="text-xs text-gray-400">Demo Mode · v1.0</span>
        </div>
      </div>

    </aside>
  )
}
